/*
 * The reducer takes care of our data
 * Using actions, we can change our application state
 * To add a new action, add it to the switch statement in the homeReducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return objectAssign({}, state, {
 *       stateVariable: action.var
 *   });
 */

import {
	SET_ERROR_MESSAGE,
	SET_CURRENT_BIDS,
	SET_HOME_SCREEN_LOADING,
	SET_TOS_ENABLED
} from '../constants/AppConstants';

const initialState = {
	errorMessage: '',
	homeScreenLoading: false,
	currentBids: {},
	winningBids: [],
	losingBids: [],
	isTOSEnabled: false
}
// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const objectAssign = Object.assign || require('object.assign');

// Takes care of changing the application state
//Never mutate or manipulate state directly. Always return a new state.
export default (state = initialState, action = null) => {
	switch (action.type) {
		case SET_ERROR_MESSAGE:
			return objectAssign({}, state, {
				errorMessage: action.message
			});
		case SET_HOME_SCREEN_LOADING:
			return objectAssign({}, state, {
				homeScreenLoading: action.homeScreenLoading
			});
		case SET_CURRENT_BIDS:
			return objectAssign({}, state, {
				currentBids: action.currentBids
			});
		case SET_TOS_ENABLED:{	
			const isTOSEnabled = action.payload;
			return {
				...state,
				isTOSEnabled
			  }
		}
		default:
			return state;
	}
};


